import { createRouteLoader, WrapRouteComponent, RouteErrorComponent } from '@ice/runtime';
import type { CreateRoutes } from '@ice/runtime';
const createRoutes: CreateRoutes = ({
  requestContext,
  renderMode
}) => [{
  path: 'myBeautifulArchive/components/CityMallPicker/useCityMallPicker',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-components-citymallpicker-usecitymallpicker" */'@/pages/myBeautifulArchive/components/CityMallPicker/useCityMallPicker');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/components/CityMallPicker/useCityMallPicker',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/components/CityMallPicker/useCityMallPicker',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-components-citymallpicker-usecitymallpicker',
  index: undefined,
  id: 'myBeautifulArchive/components/CityMallPicker/useCityMallPicker',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive/components/ResidentCityPicker',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-components-residentcitypicker-index" */'@/pages/myBeautifulArchive/components/ResidentCityPicker/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/components/ResidentCityPicker',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/components/ResidentCityPicker',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-components-residentcitypicker-index',
  index: true,
  id: 'myBeautifulArchive/components/ResidentCityPicker',
  exact: true,
  exports: ["default"]
}, {
  path: 'personalInfoDownload/components/VerifyCodeDialog',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_personalinfodownload-components-verifycodedialog-index" */'@/pages/personalInfoDownload/components/VerifyCodeDialog/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'personalInfoDownload/components/VerifyCodeDialog',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'personalInfoDownload/components/VerifyCodeDialog',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'personalinfodownload-components-verifycodedialog-index',
  index: true,
  id: 'personalInfoDownload/components/VerifyCodeDialog',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive/components/InterestTagPicker',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-components-interesttagpicker-index" */'@/pages/myBeautifulArchive/components/InterestTagPicker/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/components/InterestTagPicker',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/components/InterestTagPicker',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-components-interesttagpicker-index',
  index: true,
  id: 'myBeautifulArchive/components/InterestTagPicker',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive/components/InterestTagPicker/types',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-components-interesttagpicker-types" */'@/pages/myBeautifulArchive/components/InterestTagPicker/types');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/components/InterestTagPicker/types',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/components/InterestTagPicker/types',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-components-interesttagpicker-types',
  index: undefined,
  id: 'myBeautifulArchive/components/InterestTagPicker/types',
  exact: true,
  exports: ["extractInterestTagGroups", "formatInterestTagIds", "formatInterestTagsValue", "mergeCategoriesWithSavedTags", "normalizeInterestTagGroups", "parseInterestTagIds", "parseInterestTagsValue"]
}, {
  path: 'myBeautifulArchive/components/CityMallPicker/helpers',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-components-citymallpicker-helpers" */'@/pages/myBeautifulArchive/components/CityMallPicker/helpers');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/components/CityMallPicker/helpers',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/components/CityMallPicker/helpers',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-components-citymallpicker-helpers',
  index: undefined,
  id: 'myBeautifulArchive/components/CityMallPicker/helpers',
  exact: true,
  exports: ["CITY_ITEM_HEIGHT_RPX", "CLOSE_ICON", "EMPTY_LOCATION", "RADIO_CHECKED_ICON", "RELOCATE_ICON", "SCROLL_MAX_RETRIES", "SCROLL_RETRY_INTERVAL", "SEARCH_ICON", "STORE_ITEM_HEIGHT_RPX", "buildStoreRequestParams", "findCityByLocation", "findStoreById", "getStoreCacheKey", "resolveDefaultCity", "scrollCityIntoView", "scrollStoreIntoView", "scrollToOffset"]
}, {
  path: 'myBeautifulArchive/components/PickerHideSwitch',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-components-pickerhideswitch-index" */'@/pages/myBeautifulArchive/components/PickerHideSwitch/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/components/PickerHideSwitch',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/components/PickerHideSwitch',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-components-pickerhideswitch-index',
  index: true,
  id: 'myBeautifulArchive/components/PickerHideSwitch',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive/components/ProfileSkeleton',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-components-profileskeleton-index" */'@/pages/myBeautifulArchive/components/ProfileSkeleton/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/components/ProfileSkeleton',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/components/ProfileSkeleton',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-components-profileskeleton-index',
  index: true,
  id: 'myBeautifulArchive/components/ProfileSkeleton',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive/components/BirthdayPicker',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-components-birthdaypicker-index" */'@/pages/myBeautifulArchive/components/BirthdayPicker/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/components/BirthdayPicker',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/components/BirthdayPicker',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-components-birthdaypicker-index',
  index: true,
  id: 'myBeautifulArchive/components/BirthdayPicker',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive/components/CityMallPicker',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-components-citymallpicker-index" */'@/pages/myBeautifulArchive/components/CityMallPicker/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/components/CityMallPicker',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/components/CityMallPicker',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-components-citymallpicker-index',
  index: true,
  id: 'myBeautifulArchive/components/CityMallPicker',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive/components/CityMallPicker/types',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-components-citymallpicker-types" */'@/pages/myBeautifulArchive/components/CityMallPicker/types');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/components/CityMallPicker/types',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/components/CityMallPicker/types',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-components-citymallpicker-types',
  index: undefined,
  id: 'myBeautifulArchive/components/CityMallPicker/types',
  exact: true,
  exports: ["normalizeCityId", "normalizeCityItem", "normalizeStoreId"]
}, {
  path: 'systemMsgList/components/interestMessageList',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-components-interestmessagelist-index" */'@/pages/systemMsgList/components/interestMessageList/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/components/interestMessageList',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/components/interestMessageList',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-components-interestmessagelist-index',
  index: true,
  id: 'systemMsgList/components/interestMessageList',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive/components/AvatarUpload',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-components-avatarupload-index" */'@/pages/myBeautifulArchive/components/AvatarUpload/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/components/AvatarUpload',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/components/AvatarUpload',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-components-avatarupload-index',
  index: true,
  id: 'myBeautifulArchive/components/AvatarUpload',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive/components/GenderPicker',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-components-genderpicker-index" */'@/pages/myBeautifulArchive/components/GenderPicker/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/components/GenderPicker',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/components/GenderPicker',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-components-genderpicker-index',
  index: true,
  id: 'myBeautifulArchive/components/GenderPicker',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive/components/ProfileForm',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-components-profileform-index" */'@/pages/myBeautifulArchive/components/ProfileForm/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/components/ProfileForm',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/components/ProfileForm',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-components-profileform-index',
  index: true,
  id: 'myBeautifulArchive/components/ProfileForm',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive/utils/buildProfileSaveParams',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-utils-buildprofilesaveparams" */'@/pages/myBeautifulArchive/utils/buildProfileSaveParams');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/utils/buildProfileSaveParams',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/utils/buildProfileSaveParams',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-utils-buildprofilesaveparams',
  index: undefined,
  id: 'myBeautifulArchive/utils/buildProfileSaveParams',
  exact: true,
  exports: ["EMPTY_CITY_INFO", "EMPTY_FAVORITE_MALL", "PROFILE_SOURCE", "buildProfileClearPayload", "buildProfileSaveParams", "buildProfileSavePayload", "getChangedProfileFields", "isProfileSaveField"]
}, {
  path: 'myBeautifulArchive/utils/mapProfileDetailToForm',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-utils-mapprofiledetailtoform" */'@/pages/myBeautifulArchive/utils/mapProfileDetailToForm');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/utils/mapProfileDetailToForm',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/utils/mapProfileDetailToForm',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-utils-mapprofiledetailtoform',
  index: undefined,
  id: 'myBeautifulArchive/utils/mapProfileDetailToForm',
  exact: true,
  exports: ["extractProfileDetail", "mapProfileDetailToForm"]
}, {
  path: 'myBeautifulArchive/utils/getMtopErrorMessage',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-utils-getmtoperrormessage" */'@/pages/myBeautifulArchive/utils/getMtopErrorMessage');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/utils/getMtopErrorMessage',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/utils/getMtopErrorMessage',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-utils-getmtoperrormessage',
  index: undefined,
  id: 'myBeautifulArchive/utils/getMtopErrorMessage',
  exact: true,
  exports: ["getMtopErrorMessage"]
}, {
  path: 'myBeautifulArchive/utils/validateProfileForm',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-utils-validateprofileform" */'@/pages/myBeautifulArchive/utils/validateProfileForm');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/utils/validateProfileForm',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/utils/validateProfileForm',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-utils-validateprofileform',
  index: undefined,
  id: 'myBeautifulArchive/utils/validateProfileForm',
  exact: true,
  exports: ["validateProfileForm"]
}, {
  path: 'systemMsgList/recprder/aiChannelpushRecorder',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-recprder-aichannelpushrecorder" */'@/pages/systemMsgList/recprder/aiChannelpushRecorder');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/recprder/aiChannelpushRecorder',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/recprder/aiChannelpushRecorder',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-recprder-aichannelpushrecorder',
  index: undefined,
  id: 'systemMsgList/recprder/aiChannelpushRecorder',
  exact: true,
  exports: ["default", "recordConfig"]
}, {
  path: 'systemMsgList/recprder/broadcastMsgsRecorder',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-recprder-broadcastmsgsrecorder" */'@/pages/systemMsgList/recprder/broadcastMsgsRecorder');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/recprder/broadcastMsgsRecorder',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/recprder/broadcastMsgsRecorder',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-recprder-broadcastmsgsrecorder',
  index: undefined,
  id: 'systemMsgList/recprder/broadcastMsgsRecorder',
  exact: true,
  exports: ["default", "recordConfig"]
}, {
  path: 'myBeautifulArchive/utils/formatSelectedAddr',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-utils-formatselectedaddr" */'@/pages/myBeautifulArchive/utils/formatSelectedAddr');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/utils/formatSelectedAddr',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/utils/formatSelectedAddr',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-utils-formatselectedaddr',
  index: undefined,
  id: 'myBeautifulArchive/utils/formatSelectedAddr',
  exact: true,
  exports: ["formatSelectedAddr", "getDeepestAddrCode", "getDeepestDivisionToken", "isAddrSelectionComplete", "isValidAddrName", "mapSelectedAddrToFormFields", "restoreDefaultAddr"]
}, {
  path: 'systemMsgList/components/ListLoading',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-components-listloading-index" */'@/pages/systemMsgList/components/ListLoading/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/components/ListLoading',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/components/ListLoading',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-components-listloading-index',
  index: true,
  id: 'systemMsgList/components/ListLoading',
  exact: true,
  exports: ["default"]
}, {
  path: 'systemMsgList/components/messageList',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-components-messagelist-index" */'@/pages/systemMsgList/components/messageList/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/components/messageList',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/components/messageList',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-components-messagelist-index',
  index: true,
  id: 'systemMsgList/components/messageList',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive/utils/buildBioEditUrl',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-utils-buildbioediturl" */'@/pages/myBeautifulArchive/utils/buildBioEditUrl');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/utils/buildBioEditUrl',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/utils/buildBioEditUrl',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-utils-buildbioediturl',
  index: undefined,
  id: 'myBeautifulArchive/utils/buildBioEditUrl',
  exact: true,
  exports: ["buildBioEditUrl"]
}, {
  path: 'myBeautifulArchive/utils/weexInputProps',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-utils-weexinputprops" */'@/pages/myBeautifulArchive/utils/weexInputProps');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/utils/weexInputProps',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/utils/weexInputProps',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-utils-weexinputprops',
  index: undefined,
  id: 'myBeautifulArchive/utils/weexInputProps',
  exact: true,
  exports: ["PLACEHOLDER_COLOR", "bindTextChange", "cx", "getMultiLineInputProps", "getSingleLineInputProps", "getWeexSingleLineInputProps", "getWeexTextareaProps", "isWeex", "measureElementHeight", "scrollElementTo", "webOnlyClass"]
}, {
  path: 'systemMsgList/recprder/fansMsgsRecorder',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-recprder-fansmsgsrecorder" */'@/pages/systemMsgList/recprder/fansMsgsRecorder');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/recprder/fansMsgsRecorder',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/recprder/fansMsgsRecorder',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-recprder-fansmsgsrecorder',
  index: undefined,
  id: 'systemMsgList/recprder/fansMsgsRecorder',
  exact: true,
  exports: ["default", "recordConfig"]
}, {
  path: 'systemMsgList/recprder/myMsgsRecorder',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-recprder-mymsgsrecorder" */'@/pages/systemMsgList/recprder/myMsgsRecorder');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/recprder/myMsgsRecorder',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/recprder/myMsgsRecorder',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-recprder-mymsgsrecorder',
  index: undefined,
  id: 'systemMsgList/recprder/myMsgsRecorder',
  exact: true,
  exports: ["default", "recordConfig"]
}, {
  path: 'myBeautifulArchive/utils/getHostName',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-utils-gethostname" */'@/pages/myBeautifulArchive/utils/getHostName');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/utils/getHostName',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/utils/getHostName',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-utils-gethostname',
  index: undefined,
  id: 'myBeautifulArchive/utils/getHostName',
  exact: true,
  exports: ["getHostName"]
}, {
  path: 'myBeautifulArchive/useProfileForm',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-useprofileform" */'@/pages/myBeautifulArchive/useProfileForm');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/useProfileForm',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/useProfileForm',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-useprofileform',
  index: undefined,
  id: 'myBeautifulArchive/useProfileForm',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive/utils/platform',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-utils-platform" */'@/pages/myBeautifulArchive/utils/platform');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/utils/platform',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/utils/platform',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-utils-platform',
  index: undefined,
  id: 'myBeautifulArchive/utils/platform',
  exact: true,
  exports: ["BIO_TEXTAREA_HEIGHT_RPX", "BIO_TEXTAREA_ROWS", "INPUT_FONT_SIZE_PX", "INPUT_TEXT_COLOR", "PICKER_ITEM_HEIGHT_PX", "PICKER_ITEM_HEIGHT_RPX", "PICKER_VIEW_HEIGHT_RPX", "PLACEHOLDER_COLOR", "bindTextChange", "cx", "getMultiLineInputProps", "getPickerIndexFromWeexOffset", "getPickerIndexFromWeexScroll", "getPickerLayoutPx", "getSingleLineInputProps", "getWeexDialogProps", "getWeexInputStyle", "getWeexMultiLineInputStyle", "getWeexRpxPx", "getWeexScrollOffsetY", "getWeexTextareaProps", "isWeex", "measureElementHeight", "scrollElementTo", "scrollWeexListToIndex", "webOnlyClass"]
}, {
  path: 'personalInfoDownloadRecord',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_personalinfodownloadrecord-index" */'@/pages/personalInfoDownloadRecord/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'personalInfoDownloadRecord',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'personalInfoDownloadRecord',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'personalinfodownloadrecord-index',
  index: true,
  id: 'personalInfoDownloadRecord',
  exact: true,
  exports: ["default"]
}, {
  path: 'systemMsgList/useSystemMsgList',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-usesystemmsglist" */'@/pages/systemMsgList/useSystemMsgList');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/useSystemMsgList',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/useSystemMsgList',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-usesystemmsglist',
  index: undefined,
  id: 'systemMsgList/useSystemMsgList',
  exact: true,
  exports: ["default"]
}, {
  path: 'personalInfoDownload',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_personalinfodownload-index" */'@/pages/personalInfoDownload/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'personalInfoDownload',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'personalInfoDownload',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'personalinfodownload-index',
  index: true,
  id: 'personalInfoDownload',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-index" */'@/pages/myBeautifulArchive/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-index',
  index: true,
  id: 'myBeautifulArchive',
  exact: true,
  exports: ["default"]
}, {
  path: 'myBeautifulArchive/types',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_mybeautifularchive-types" */'@/pages/myBeautifulArchive/types');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'myBeautifulArchive/types',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'myBeautifulArchive/types',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'mybeautifularchive-types',
  index: undefined,
  id: 'myBeautifulArchive/types',
  exact: true,
  exports: ["DEFAULT_PROFILE_FORM", "GENDER_OPTIONS"]
}, {
  path: 'publicAgreements',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_publicagreements-index" */'@/pages/publicAgreements/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'publicAgreements',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'publicAgreements',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'publicagreements-index',
  index: true,
  id: 'publicAgreements',
  exact: true,
  exports: ["default"]
}, {
  path: 'privacyCenter/config',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_privacycenter-config" */'@/pages/privacyCenter/config');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'privacyCenter/config',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'privacyCenter/config',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'privacycenter-config',
  index: undefined,
  id: 'privacyCenter/config',
  exact: true,
  exports: ["permissionItems", "personalInfoItems", "userInfoItems"]
}, {
  path: 'accessControl',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_accesscontrol-index" */'@/pages/accessControl/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'accessControl',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'accessControl',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'accesscontrol-index',
  index: true,
  id: 'accessControl',
  exact: true,
  exports: ["default"]
}, {
  path: 'privacyCenter',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_privacycenter-index" */'@/pages/privacyCenter/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'privacyCenter',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'privacyCenter',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'privacycenter-index',
  index: true,
  id: 'privacyCenter',
  exact: true,
  exports: ["default"]
}, {
  path: 'systemMsgList',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-index" */'@/pages/systemMsgList/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-index',
  index: true,
  id: 'systemMsgList',
  exact: true,
  exports: ["default"]
}, {
  path: 'controlInfo',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_controlinfo-index" */'@/pages/controlInfo/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'controlInfo',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'controlInfo',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'controlinfo-index',
  index: true,
  id: 'controlInfo',
  exact: true,
  exports: ["default"]
}, {
  path: 'setting/recorder',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_setting-recorder" */'@/pages/setting/recorder');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'setting/recorder',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'setting/recorder',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'setting-recorder',
  index: undefined,
  id: 'setting/recorder',
  exact: true,
  exports: ["default", "recordConfig"]
}, {
  path: 'errorPage',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_errorpage-index" */'@/pages/errorPage/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'errorPage',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'errorPage',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'errorpage-index',
  index: true,
  id: 'errorPage',
  exact: true,
  exports: ["default"]
}, {
  path: 'malllist',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_malllist-index" */'@/pages/malllist/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'malllist',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'malllist',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'malllist-index',
  index: true,
  id: 'malllist',
  exact: true,
  exports: ["default"]
}, {
  path: 'message',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_message-index" */'@/pages/message/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'message',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'message',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'message-index',
  index: true,
  id: 'message',
  exact: true,
  exports: ["default"]
}, {
  path: 'setting',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_setting-index" */'@/pages/setting/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'setting',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'setting',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'setting-index',
  index: true,
  id: 'setting',
  exact: true,
  exports: ["default"]
}, {
  path: 'NavBar',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_navbar-index" */'@/pages/NavBar/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'NavBar',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'NavBar',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'navbar-index',
  index: true,
  id: 'NavBar',
  exact: true,
  exports: ["default", "showSelfNav"]
}, {
  path: 'about',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_about-index" */'@/pages/about/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'about',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'about',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'about-index',
  index: true,
  id: 'about',
  exact: true,
  exports: ["default"]
}];
export default createRoutes;